import { PublicKey } from '@solana/web3.js'
import UpdownIDL from './idl/updown.json'
import TreasuryIDL from './idl/treasury.json'
import OneVsOneIDL from './idl/one_vs_one.json'
import BullseyeIDL from './idl/bullseye.json'
import MockVerifierIDL from './idl/mock_verifier.json'
import SetupIDL from './idl/setup.json'
import RaceIDL from './idl/race.json'
import UpdownAiIDL from './idl/updown_ai.json'

const IDL_ADDRESS = (idl: { address: string }) => idl.address as string

export const TOKEN_ADDRESS =
  import.meta.env.VITE_TOKEN_ADDRESS ??
  '6aRnDcyXiqRXg46MkGSA9t1CE99TtbVVVYUhHjG67gPY'
export const TOKEN_PUB_KEY = new PublicKey(TOKEN_ADDRESS)

export const MOCK_VERIFIER_PROGRAM_ID = new PublicKey(
  IDL_ADDRESS(MockVerifierIDL as { address: string })
)

export const TREASURY_PROGRAM_ADDRESS = IDL_ADDRESS(
  TreasuryIDL as { address: string }
)
export const TREASURY_PROGRAM_ID = new PublicKey(TREASURY_PROGRAM_ADDRESS)

export const UPDOWN_PROGRAM_ADDRESS = IDL_ADDRESS(
  UpdownIDL as { address: string }
)
export const UPDOWN_PROGRAM_ID = new PublicKey(UPDOWN_PROGRAM_ADDRESS)

export const ONE_VS_ONE_PROGRAM_ADDRESS = IDL_ADDRESS(
  OneVsOneIDL as { address: string }
)
export const ONE_VS_ONE_PROGRAM_ID = new PublicKey(ONE_VS_ONE_PROGRAM_ADDRESS)

export const BULLSEYE_PROGRAM_ADDRESS = IDL_ADDRESS(
  BullseyeIDL as { address: string }
)
export const BULLSEYE_PROGRAM_ID = new PublicKey(BULLSEYE_PROGRAM_ADDRESS)

export const SETUP_PROGRAM_ADDRESS = IDL_ADDRESS(
  SetupIDL as { address: string }
)
export const SETUP_PROGRAM_ID = new PublicKey(SETUP_PROGRAM_ADDRESS)

export const RACE_PROGRAM_ADDRESS = IDL_ADDRESS(RaceIDL as { address: string })
export const RACE_PROGRAM_ID = new PublicKey(RACE_PROGRAM_ADDRESS)

export const UPDOWN_AI_PROGRAM_ADDRESS = IDL_ADDRESS(
  UpdownAiIDL as { address: string }
)
export const UPDOWN_AI_PROGRAM_ID = new PublicKey(UPDOWN_AI_PROGRAM_ADDRESS)
